export default {
  upload: {
    uploadedFile: "Uploaded file",
    upload: "Upload",
    unsupportedType: "This file type is not supported.",
    pendingUpload: "Pending upload",
    uploaded: "Uploaded",
    replaceFile: "Replace file",
    removeFile: "Remove file",
  },
  productModal: {
    subtitle: "SKU, store, market and representative.",
    packagingName: "Packaging name",
    productName: "Product name",
    enterPackagingName: "Enter packaging name",
    enterProductName: "Enter product name",
    enterSku: "Enter SKU",
    selectDate: "Select date",
    targetMarket: "Target Market",
    selectTargetMarket: "Select target market",
    authorizedRepresentative: "Authorized Representative",
    addRepresentative: "Add a representative for this product.",
    representativeDisabledHint: "Leave disabled if an Authorized Representative is not required.",
    chooseRepresentative: "Choose representative",
    custom: "Custom",
    lappaListedAsRepresentative: "{{name}} will be listed as the Authorized Representative for this product.",
    useAiSuggestion: "Use AI suggestion",
    companyName: "Company Name",
    companyNamePlaceholder: "Company name",
    streetAddress: "Full Registered Street Address",
    streetAddressPlaceholder: "Street address",
    postalCode: "Postal Code",
    postalCodePlaceholder: "Postal code",
    city: "City",
    country: "Country",
    loadingCountries: "Loading countries...",
    selectCountry: "Select country",
    noCountries: "No countries found",
    email: "Email",
    commentsPlaceholder: "Enter comments (optional)",
    otherApps: "Use this product in other Lappa applications",
    availableInInvoice: "Available in L'Invoice",
    store: "Store",
    requiredForShopify: "Required for Shopify.",
    selectStore: "Select store",
    notRequired: "Not required",
    yes: "Yes",
    no: "No",
    cloneExisting: "Clone existing",
    back: "Back",
    next: "Next",
    skip: "Skip",
    stepsAria: "Product wizard steps",
    errors: {
      skuRequired: "SKU is required",
      productNameRequired: "Product name is required",
      packagingNameRequired: "Packaging name is required",
      activeFromRequired: "Active from is required",
    },
    steps: {
      details: {
        label: "Main",
        description: "Name, SKU and dates.",
      },
      market: {
        label: "Market",
        description: "Target market and representative.",
      },
      notes: {
        label: "Notes",
        description: "Comments and other Lappa apps.",
      },
      store: {
        label: "Store",
        description: "Optional store for this product.",
      },
      review: {
        label: "Review & save",
        description: "Review the details and save.",
      },
    },
    clone: {
      titlePackaging: "Clone packaging",
      titleProduct: "Clone product",
      descriptionPackaging: "Search and select an existing packaging to copy its details into this form.",
      descriptionProduct: "Search and select an existing product to copy its details into this form.",
      searchPackaging: "Search packaging...",
      searchProducts: "Search products...",
      emptyPackaging: "No packaging items available to clone.",
      emptyProducts: "No products available to clone.",
      loadPackagingFailed: "Could not load packaging list.",
      loadProductsFailed: "Could not load product list.",
    },
  },
  form: {
    addProduct: "Add product",
    addPackaging: "Add packaging",
    editProduct: "Edit product",
    editPackaging: "Edit packaging",
    loadFailed: "Could not load this product.",
    loading: "Loading this product.",
    saveChanges: "Save changes",
    updateProduct: "Update this product.",
    updatePackaging: "Update this packaging.",
    addProductSubtitle: "Add product details.",
    addPackagingSubtitle: "Add packaging details, dimensions and material composition.",
    saveAndContinue: "Save and continue to label",
    saveDraft: "Save draft",
    saving: "Loading...",
    discardPackagingTitle: "Discard packaging?",
    discardPackagingDescription: "This packaging hasn't been created yet. If you leave now, the information you entered will be cleared.",
    discardProductTitle: "Discard product?",
    discardProductDescription: "This product hasn't been created yet. If you leave now, the information you entered will be cleared.",
    keepEditing: "Keep editing",
    discard: "Discard",
    sectionsAriaProduct: "product sections",
    sectionsAriaPackaging: "packaging sections",
    lockedNoticeProduct: "This section will be available once the product is saved.",
    lockedNoticePackaging: "This section will be available once the packaging is saved.",
    notices: {
      packagingSaved: "Packaging saved successfully. You can create a label for it if you need to.",
      productSaved: "Product saved successfully. You can create a label for it if you need to.",
      packagingSavedClient: "Packaging saved. Activate it to create a Digital Label or a Declaration of Conformity.",
      packagingSavedManager: "Packaging saved. Change its status to Active to create a Digital Label or a Declaration of Conformity.",
      packagingActivated: "Packaging activated. You can now create a Digital Label and a Declaration of Conformity.",
    },
    tabs: {
      packaging: "Packaging",
      product: "Product",
      digitalLabelPpwr: "Digital label (PPWR)",
      digitalLabelGpsr: "Digital label (GPSR)",
      documents: "Documents",
      conformity: "Document of conformity",
    },
    documents: {
      document: "Document",
      status: "Status",
      date: "Date",
      emptyTitle: "No documents yet",
      emptyProduct: "Documents uploaded for this product will appear here.",
      emptyPackaging: "Documents uploaded for this packaging will appear here.",
    },
  },
};
